<template>
    <div v-show="entry.id">{{ moment(entry.due_for).format(dueForDateFormat(entry.fee_head_id)) }}</div>
    <div v-show="!entry.id" style="width: 150px; margin: auto">
        <DatePicker :ref="`due_for_${index}`"
                    :reference="`due_for_${index}`"
                    :on-change="onChange"
                    :value="null"
                    date-format="YYYY-MM-DD"
                    :picker-format="entry.datepickerOptions?.pickerFormat"
                    :view-mode="entry.datepickerOptions?.viewMode"
                    :min-view-mode="entry.datepickerOptions?.viewMode"
                    :error="error"/>
    </div>
</template>

<script>
import DatePicker from "../../../components/DatePicker";
import moment from "moment";

export default {
    components: {
        DatePicker,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        dueForDateFormat: {
            type: Function,
            required: true,
        },
        onDueForChange: {
            type: Function,
            required: false,
        },
        error: {
            type: String,
            required: false,
        },
    },
    methods: {
        moment(date) {
            return date ? moment(date) : moment()
        },
        onChange(ref, date) {
            if (!this.entry.id) {
                this.entry.due_for = date
                if (this.onDueForChange) {
                    this.onDueForChange(this.index)
                }
            }
        },
        forceUpdate() {
            this.$refs[`due_for_${this.index}`].forceUpdate()
        },
    }
}
</script>

<style scoped>

</style>
